import React from "react";
import { FaRegStar, FaRegCommentDots } from "react-icons/fa";
import { FaTelegramPlane } from "react-icons/fa";


const Wrapper = ({ children }) => <div>{children}</div>;

const SuggestionsFeedback = () => {
    return (
        <Wrapper>
            <div className="container py-5">
                <div className="card border-0 shadow-sm p-4">
                    <h4 className="fw-bold text-dark">Submit Feedback or Suggestion</h4>
                    <p className="text-muted mb-4">
                        See what users are saying and sharing about the partnered tourist spots.
                    </p>
                    <div className="col-md-12">
                        <div className="mb-3">
                            <label htmlFor="subject" className="form-label">Subject</label>
                            <input
                                type="text"
                                className="form-control bg-light"
                                id="subject"
                                placeholder="Enter subject"
                            />
                        </div>
                    </div>
                    <div className="mb-3">
                        <label htmlFor="category" className="form-label "> Category</label>
                        <select className="form-select bg-light text-muted" id="category">
                            <option value="">Select a category</option>
                            <option value="suggestion">Suggestion</option>
                            <option value="feedback">Feedback</option>
                            <option value="complaint">Complaint</option>
                            <option value="other">Other</option>
                        </select>
                    </div>
                    <div className="mb-3">
                        <label htmlFor="message" className="form-label">Message</label>
                        <textarea
                            className="form-control bg-light"
                            id="message"
                            rows="3"
                            placeholder="Type your message here..."
                        ></textarea>
                    </div>
                    <div className="row d-flex">
                        <div className="col-lg-6">
                            <div className="mb-3">
                                <label htmlFor="name" className="form-label">Name</label>
                                <input
                                    type="text"
                                    className="form-control bg-light"
                                    id="name"
                                    placeholder="Enter your name"
                                />
                                <label htmlFor="name" className="form-label text-muted mt-2">You can submit feedback anonymously</label>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="mb-3">
                                <label htmlFor="email" className="form-label">Email address</label>
                                <input
                                    type="email"
                                    className="form-control bg-light"
                                    id="email"
                                    placeholder="name@example.com"
                                />
                                <label htmlFor="email" className="form-label text-muted mt-2">if you like a response or folloe-up</label>
                            </div>
                        </div>
                    </div>
                    <button type="submit" className="btn btn-primary align-items-center gap-2 text-white" style={{ width: "200px" }}>
                        Submit
                    </button>
                </div>
            </div>
            <div className="container pb-5">
                <div className="card border-0 shadow-sm p-4">
                    <h4 className="fw-bold text-dark">Submit Feedback or Suggestion</h4>
                    <p className="text-muted mb-4">
                        See what users are saying and sharing about the partnered tourist spots.
                    </p>

                    <div className="card border-0 shadow-sm p-4 mb-4 bg-light">
                        <div className="d-flex justify-content-between align-items-start">
                            <h6 className="fw-bold text-dark mb-0">Dark Mode Option</h6>
                            <span className="badge bg-light text-primary px-3 py-1 rounded-pill border border-primary">New</span>
                        </div>
                        <p className="text-muted small mt-2 mb-2">
                            Submitted by: <strong>TechSavvy Venue</strong> on <span>Jul 22, 2024</span>
                        </p>
                        <p className="text-secondary mb-2">
                            It would be great to have a dark mode option for the partner portal. It's easier on the eyes, especially during night shifts.
                        </p>
                        <p className="text-muted small mb-0">
                            Type: <span className="text-primary fw-semibold">Feature Request</span>
                        </p>
                    </div>
                    <div className="card border-0 shadow-sm p-4 mb-4 bg-light">
                        <div className="d-flex justify-content-between align-items-start">
                            <h6 className="fw-bold text-dark mb-0">Login Issues</h6>
                            <span className="badge bg-light text-danger px-3 py-1 rounded-pill border border-danger">Urgent</span>
                        </div>
                        <p className="text-muted small mt-2 mb-2">
                            Submitted by: <strong>GuestUser123</strong> on <span>Aug 2, 2024</span>
                        </p>
                        <p className="text-secondary mb-2">
                            I’m unable to log into the dashboard after the last update. Please resolve it ASAP.
                        </p>
                        <p className="text-muted small mb-0">
                            Type: <span className="text-danger fw-semibold">Complaint</span>
                        </p>
                    </div>
                    <div className="card border-0 shadow-sm p-4 mb-4 bg-light">
                        <div className="d-flex justify-content-between align-items-start">
                            <h6 className="fw-bold text-dark mb-0">Add Multi-Language Support</h6>
                            <span className="badge bg-light text-success px-3 py-1 rounded-pill border border-success">Reviewed</span>
                        </div>
                        <p className="text-muted small mt-2 mb-2">
                            Submitted by: <strong>LocalTourOps</strong> on <span>Sep 10, 2024</span>
                        </p>
                        <p className="text-secondary mb-2">
                            Please consider adding support for local languages to help regional partners.
                        </p>
                        <p className="text-muted small mb-0">
                            Type: <span className="text-success fw-semibold">Suggestion</span>
                        </p>
                    </div>
                </div>
            </div>
        </Wrapper>
    );
};

export default SuggestionsFeedback;
